interface SpotifyEmbedProps {
  episodeId?: string
  embedUrl?: string
  title?: string
  className?: string
  iframeClassName?: string
}

function buildEmbedUrl(episodeId?: string, embedUrl?: string): string | null {
  if (embedUrl && embedUrl.trim().length > 0) {
    return embedUrl
  }

  if (episodeId && episodeId.trim().length > 0) {
    return `https://open.spotify.com/embed/episode/${episodeId}`
  }

  return null
}

export default function SpotifyEmbed({
  episodeId,
  embedUrl,
  title,
  className = '',
  iframeClassName = '',
}: SpotifyEmbedProps) {
  const resolvedEmbedUrl = buildEmbedUrl(episodeId, embedUrl)

  if (!resolvedEmbedUrl) {
    return (
      <div
        className={`flex h-[232px] items-center justify-center rounded-xl bg-border-light px-4 text-center text-sm font-semibold text-text-muted ${className}`}
      >
        Spotify player unavailable.
      </div>
    )
  }

  return (
    <div className={`overflow-hidden rounded-xl bg-black shadow-md ${className}`}>
      <iframe
        src={resolvedEmbedUrl}
        title={title ?? 'Spotify episode'}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className={`block h-[232px] w-full border-0 ${iframeClassName}`}
      />
    </div>
  )
}
